<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="representativePlacements.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
      @expand-change="onExpandRow"
    >
      <el-table-column
        type="expand"
        fixed
      >
        <template slot-scope="scope">
          <div
            v-loading="itemLoading === scope.row.id"
            style="width: 1000px;"
          >
            <el-table
              v-if="items.find(i => i.representative_placement_id == scope.row.id)"
              :data="items.filter(i => i.representative_placement_id == scope.row.id)"
              border
            >
              <el-table-column
                label="Név"
                show-overflow-tooltip
                width="240"
              >
                <template slot-scope="props">
                  {{ props.row.name }}
                </template>
              </el-table-column>
              <el-table-column
                label="Mennyiség"
                show-overflow-tooltip
                width="100"
              >
                <template slot-scope="props">
                  {{ props.row.count }} db
                </template>
              </el-table-column>
              <el-table-column
                label="Ár típus"
                show-overflow-tooltip
                width="130"
              >
                <template slot-scope="props">
                  <span v-if="props.row.price_type_id">{{ props.row.price_type && props.row.price_type.name }}</span>
                  <span v-else>Egyedi ár</span>
                </template>
              </el-table-column>
              <el-table-column
                label="Beszállító"
                show-overflow-tooltip
              >
                <template slot-scope="props">
                  {{ props.row.supplier_name }}
                </template>
              </el-table-column>
              <el-table-column
                label="Szav. idő"
                show-overflow-tooltip
              >
                <template slot-scope="props">
                  {{ props.row.expiration_date | date }}
                </template>
              </el-table-column>
              <el-table-column
                prop="net_price"
                label="Nettó ár"
                show-overflow-tooltip
                width="130"
              >
                <template slot-scope="props">
                  {{ props.row.net_price | currency }}
                </template>
              </el-table-column>
              <el-table-column
                label="Bruttó ár"
                show-overflow-tooltip
                width="130"
              >
                <template slot-scope="props">
                  {{ (props.row.net_price * (props.row.vat / 100 + 1)) | currency }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="70"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="representativePlacement"
            :options="['settings', 'export']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :representative-placement="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="representativePlacements.per_page"
        layout="total, prev, pager, next"
        :total="representativePlacements.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        itemLoading: 0,
        items: [],
        currentSort: {
          prop: 'created_at',
          order: 'desc',
        },
      };
    },
    computed: {
      representativePlacements() {
        return this.$store.getters['representativePlacement/representativePlacements'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['representativePlacement/tableConfig']));
      },
      loading() {
        return this.$store.getters['representativePlacement/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('representativePlacement/setFilterString', '');
      this.$store.commit('representativePlacement/setCurrentPage', this.currentPage);
      this.$store.commit('representativePlacement/setSorting', this.currentSort);
      await this.$store.dispatch('representativePlacement/fetchAll');
    },
    methods: {
      async onExpandRow(row) {
        if (row && !this.items.find(i => i.representative_placement_id === row.id)) {
          this.itemLoading = row.id;
          const items = await axios.get(`/api/representative-placements/${row.id}/items`);
          this.items.push(...items);
          this.itemLoading = 0;
        }
      },
      handleCurrentChange(val) {
        this.$store.commit('representativePlacement/setCurrentPage', val);
        this.$store.dispatch('representativePlacement/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('representativePlacement/setSorting', { prop, order });
          this.$store.dispatch('representativePlacement/fetchAll');
        }
      },
    },
  };
</script>

